"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OPERATION = exports.EVENTS = exports.UNIT = exports.PROJECTION_MODE = exports.COORDINATE_SYSTEM = void 0;

var _log = _interopRequireDefault(require("../utils/log"));

var COORDINATE_SYSTEM = {
  DEFAULT: -1,
  LNGLAT: 1,
  METER_OFFSETS: 2,
  LNGLAT_OFFSETS: 3,
  CARTESIAN: 0
};
exports.COORDINATE_SYSTEM = COORDINATE_SYSTEM;
Object.defineProperty(COORDINATE_SYSTEM, 'IDENTITY', {
  get: function get() {
    _log.default.deprecated('COORDINATE_SYSTEM.IDENTITY', 'COORDINATE_SYSTEM.CARTESIAN')();

    return 0;
  }
});
var PROJECTION_MODE = {
  WEB_MERCATOR: 1,
  GLOBE: 2,
  WEB_MERCATOR_AUTO_OFFSET: 4,
  IDENTITY: 0
};
exports.PROJECTION_MODE = PROJECTION_MODE;
var UNIT = {
  common: 0,
  meters: 1,
  pixels: 2
};
exports.UNIT = UNIT;
var EVENTS = {
  click: {
    handler: 'onClick'
  },
  panstart: {
    handler: 'onDragStart'
  },
  panmove: {
    handler: 'onDrag'
  },
  panend: {
    handler: 'onDragEnd'
  }
};
exports.EVENTS = EVENTS;
var OPERATION = {
  DRAW: 'draw',
  MASK: 'mask',
  TERRAIN: 'terrain'
};
exports.OPERATION = OPERATION;
//# sourceMappingURL=constants.js.map